// import cubejs from "@cubejs-client/core";
// import { CubeProvider } from "@cubejs-client/react";
// import WebSocketTransport from "@cubejs-client/ws-transport";
// import React from "react";

// let apiTokenPromise;

// export const cubejsApi = cubejs(
//   () => {
//     if (!apiTokenPromise) {
//       apiTokenPromise = fetch('https://cube.hikemm.hikar.cloud/auth/cubejs-token')
//         .then((res) => res.json())
//         .then((r) => r.token);
//     }
//     return apiTokenPromise;
//   },
//   {
//     apiUrl: 'https://cube.hikemm.hikar.cloud/cubejs-api/v1/',
//   }
// );
// // branch

// function CubeJsApiWrapper(props) {
//     return (
//         <CubeProvider cubejsApi={cubejsApi}>
//           {props.children}
//         </CubeProvider>
//        )
// }

// export default CubeJsApiWrapper;


import cubejs from "@cubejs-client/core";
import { CubeProvider } from "@cubejs-client/react";
import WebSocketTransport from "@cubejs-client/ws-transport";
import React from "react";

let apiTokenPromise;

export const cubejsApi = cubejs(
  () => {
    if (!apiTokenPromise) {
      apiTokenPromise = fetch(`${process.env.REACT_APP_CUBE_URL}/auth/cubejs-token`)
        .then((res) => res.json())
        .then((r) => r.token);
    }
    return apiTokenPromise;
  },
  {
    apiUrl: `${process.env.REACT_APP_CUBE_URL}/cubejs-api/v1`,
  }
);
// branch

function CubeJsApiWrapper(props) {
  return (
    <CubeProvider cubejsApi={cubejsApi}>
      {props.children}
    </CubeProvider>
  )
}

export default CubeJsApiWrapper;

